import { plans } from 'shared/constants';

export default function useFeatureAccess(plan, subscriptionPastDue, betaPhaseManager) {
  const hasFeatureAccess = (featureFlag) => {
    const currentPlan = plan.value;
    // The plan has not loaded yet, or could not be resolved at all.
    if (currentPlan === undefined || currentPlan === null || currentPlan.id === undefined) {
      return false;
    }
    if (betaPhaseManager.isInBeta.value) {
      return true;
    }

    if (subscriptionPastDue.value) {
      return plans.free.featureAccess[featureFlag];
    }

    const known = plans[currentPlan.id];
    if (known === undefined) {
      // A plan id this build does not know about - a pricing change, an older
      // build reading newer data. Denying access is recoverable; throwing takes
      // the whole view down with it.
      return false;
    }

    return known.featureAccess[featureFlag];
  };
  return { hasFeatureAccess };
}
